(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.menuheight = document.querySelector('.menu_both_bottom');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() { 
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.body.style.setProperty('--header-bodyheight', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // if (scrollTop != 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medencepont-fedes-kalkulator"] && !Shopify.designMode) return;
  try {
    

(function(){
 'use strict';
 const root=document.getElementById('mp-cover-calc');
 if(!root || root.dataset.init==='yes')return;
 root.dataset.init='yes';
 const form=root.querySelector('#mpc-form');
 const status=root.querySelector('#mpc-status');
 const summary=root.querySelector('#mpc-summary');
 const tech=root.querySelector('#mpc-tech');
 const price=root.querySelector('#mpc-price');
 const lines=root.querySelector('#mpc-lines');
 const login=root.querySelector('#mpc-login');
 const offerBox=root.querySelector('#mpc-offer-box');
 const offerForm=root.querySelector('#mpc-offer-form');
 const offerSubmit=root.querySelector('#mpc-offer-submit');
 const offerStatus=root.querySelector('#mpc-offer-status');
 let latestQuoteComplete=false;
 const storageKey='mp:cover:v3:'+location.pathname;
 const qs=id=>root.querySelector('#'+id);
 const segmentPreview=qs('mpc-segment-preview');
 const segmentCountEl=qs('mpc-segment-count');
 const segmentLengthEl=qs('mpc-segment-length');

 const segmentFamilies={
   mini:'standard',hexa:'standard','hexa-plus':'standard','hexa-lite':'lite','hexa-lite-plus':'lite',
   'sky-plus':'skyPlus',basic:'standard',comet:'standard',classic:'standard','comet-plus':'standard',
   'classic-plus':'standard',neptune:'standard',jupiter:'standard',triton:'standard',sky:'standard',
   supreme:'terrace',corner:'terrace'
 };
 const segmentBands={
   standard:[[0,4700,2],[4701,7000,3],[7001,9000,4],[9001,11400,5],[11401,13500,6],[13501,15500,7],[15501,18000,8],[18001,19500,9],[19501,22000,10]],
   skyPlus:[[0,4500,2],[4501,6500,3],[6501,8500,4],[8501,10500,5],[10501,12500,6]],
   lite:[[0,4150,2],[4151,6250,3],[6251,8300,4],[8301,10350,5],[10351,12450,6]],
   terrace:[[0,4500,2],[4501,7600,3],[7601,10000,4],[10001,12600,5],[12601,15100,6]]
 };
 function liveSegmentData(){
   const model=get('model');
   const lengthM=parseDecimal(get('length'));
   if(!model||!Number.isFinite(lengthM)||lengthM<=0)return null;
   const lengthMm=Math.round(lengthM*1000);
   const family=segmentFamilies[model];
   const band=(segmentBands[family]||[]).find(b=>lengthMm>=b[0]&&lengthMm<=b[1]);
   if(!band)return null;
   const segments=band[2];
   const segmentLengthMm=Math.floor((lengthMm+Math.max(0,segments-1)*50)/segments);
   return {segments,segmentLengthMm};
 }
 function updateSegmentPreview(){
   const data=liveSegmentData();
   if(!data){segmentPreview.hidden=true;segmentCountEl.textContent='—';segmentLengthEl.textContent='—';return;}
   segmentCountEl.textContent=data.segments+' db';
   segmentLengthEl.textContent=data.segmentLengthMm+' mm';
   segmentPreview.hidden=false;
 }
 const parseDecimal=s=>{const n=Number(String(s||'').trim().replace(',','.'));return Number.isFinite(n)?n:NaN;};
 const fmt=n=>new Intl.NumberFormat('hu-HU',{maximumFractionDigits:2}).format(n);
 const formatMoney=n=>new Intl.NumberFormat('hu-HU',{style:'currency',currency:'HUF',maximumFractionDigits:0}).format(n);
 const fields=()=>Array.from(form.elements).filter(e=>e.name && (e.matches('input,select')));
 const get=name=>{const item=form.elements.namedItem(name);return item?String(item.value).trim():'';};
 const current=()=>({
   model:get('model'),lengthMm:Math.round(parseDecimal(get('length'))*1000),widthMm:Math.round(parseDecimal(get('width'))*1000),
   railExtensionMm:Math.round(parseDecimal(get('railExtension'))*1000),
   extras:{},
   zip:get('zip'),town:get('town'),address:get('address')
 });
 function validate(){
   if(!form.reportValidity())return false;
   const c=current();
   if(!(Number.isInteger(c.lengthMm)&&c.lengthMm>=500&&c.lengthMm<=30000&&Number.isInteger(c.widthMm)&&c.widthMm>=500&&c.widthMm<=15000)){
      status.textContent='A hossz és a szélesség 0,5–30, illetve 0,5–15 méter közé essen.';return false;
   }
   if(!(Number.isInteger(c.railExtensionMm)&&c.railExtensionMm>=100&&c.railExtensionMm<=10000)){
      status.textContent='Add meg a sínhosszabbítást méterben.';return false;
   }
   return true;
 }
 function summaryText(){
   const sel=qs('mpc-model');
   return [
     'Fedés: '+(sel.selectedOptions[0]?.textContent||'—'),
     'Medence hossza: '+(get('length')||'—')+' m',
     'Medence szélessége: '+(get('width')||'—')+' m',
     'Sínhosszabbítás: '+(get('railExtension')||'—')+' m',
     'Szállítás: '+(get('zip')||'—')+' '+(get('town')||'—')+', '+(get('address')||'—')
   ].join('\n');
 }
 function save(){const obj={};fields().forEach(e=>{obj[e.name]=e.type==='checkbox'?e.checked:e.value;});try{sessionStorage.setItem(storageKey,JSON.stringify(obj));}catch(e){}}
 function restore(){try{const saved=JSON.parse(sessionStorage.getItem(storageKey)||'{}');fields().forEach(e=>{if(Object.prototype.hasOwnProperty.call(saved,e.name)){if(e.type==='checkbox')e.checked=Boolean(saved[e.name]);else e.value=String(saved[e.name]);}});}catch(e){}}
 function refresh(){summary.textContent=summaryText();updateSegmentPreview();tech.hidden=true;tech.textContent='';price.hidden=true;price.textContent='';lines.hidden=true;lines.replaceChildren();login.hidden=true;offerBox.hidden=true;latestQuoteComplete=false;offerStatus.textContent='';offerStatus.classList.remove('mpc-error');status.textContent='';}
 restore();refresh();
 form.addEventListener('input',()=>{save();refresh();});
 form.addEventListener('change',()=>{save();refresh();});
 login.addEventListener('click',()=>save());
 const calculate=qs('mpc-calculate');
 calculate.addEventListener('click',async()=>{
   if(!validate())return;
   save();
   login.hidden=true;price.hidden=true;lines.hidden=true;lines.replaceChildren();
   calculate.disabled=true;status.textContent='Kalkuláció lekérése…';
   try{
     const response=await fetch(root.dataset.priceApi,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',cache:'no-store',body:JSON.stringify(current())});
     const responseText=await response.text();
     let result={};
     try{result=responseText?JSON.parse(responseText):{};}catch(e){}
     if(response.status===401){status.textContent='Az ár megtekintéséhez jelentkezz be. A kitöltött adatok megmaradnak.';login.hidden=false;return;}
     if(!response.ok){status.textContent=result.message||'A kalkuláció jelenleg nem érhető el. Használd a meglévő ajánlatkérőt.';return;}
     if(result.status==='manual_review'){status.textContent='A választott műszaki összeállítás egyedi ellenőrzést igényel. Kérj ajánlatot a meglévő űrlapon.';return;}
     if(!Number.isSafeInteger(result.subtotalNetHuf)||result.subtotalNetHuf<0){status.textContent='A kalkuláció hiányos. Kérj egyedi ajánlatot.';return;}
     const total=result.status==='complete'&&Number.isSafeInteger(result.totalNetHuf);
     const resultItems=Array.isArray(result.items)?result.items:[];
     const coverItems=resultItems.filter(item=>['base','rail','extra'].includes(item.kind)&&Number.isSafeInteger(item.amountNetHuf));
     const coverListNet=coverItems.reduce((sum,item)=>sum+item.amountNetHuf,0);
     const discountItem=resultItems.find(item=>item.kind==='discount'&&Number.isSafeInteger(item.amountNetHuf));
     const discountNet=discountItem?discountItem.amountNetHuf:0;
     const discountedCoverNet=coverListNet+discountNet;
     const installationItem=resultItems.find(item=>item.kind==='installation'&&Number.isSafeInteger(item.amountNetHuf));
     const shippingItem=resultItems.find(item=>item.kind==='shipping'&&Number.isSafeInteger(item.amountNetHuf));
     const installationNet=installationItem?installationItem.amountNetHuf:0;
     const shippingNet=shippingItem?shippingItem.amountNetHuf:null;
     const calculatedNet=discountedCoverNet+installationNet+(shippingNet??0);
     const netValue=total?result.totalNetHuf:calculatedNet;
     const grossValue=Math.round(netValue*1.27);

     price.replaceChildren();
     const netLine=document.createElement('div');
     netLine.className='mpc-price-net';
     netLine.textContent=(total?'Indikatív nettó végösszeg: ':'Nettó részösszeg szállítás nélkül: ')+formatMoney(netValue);
     const grossLine=document.createElement('div');
     grossLine.className='mpc-price-gross';
     grossLine.textContent=(total?'Indikatív bruttó végösszeg: ':'Bruttó részösszeg szállítás nélkül: ')+formatMoney(grossValue);
     price.append(netLine,grossLine);
     price.hidden=false;

     lines.replaceChildren();
     const table=document.createElement('table');
     table.className='mpc-pricetable';
     const thead=document.createElement('thead');
     const hr=document.createElement('tr');
     ['Tétel megnevezése','Nettó érték','ÁFA','ÁFA érték','Bruttó érték'].forEach((label,index)=>{
       const th=document.createElement('th');th.textContent=label;if(index===0)th.scope='col';hr.append(th);
     });
     thead.append(hr);table.append(thead);
     const tbody=document.createElement('tbody');

     function addMoneyRow(label,net,className=''){
       const tr=document.createElement('tr');if(className)tr.className=className;
       const gross=Math.round(net*1.27),vat=gross-net;
       const values=[label,formatMoney(net),'27%',formatMoney(vat),formatMoney(gross)];
       const labels=['Tétel','Nettó érték','ÁFA','ÁFA érték','Bruttó érték'];
       values.forEach((value,index)=>{
         const td=document.createElement('td');td.textContent=value;td.dataset.label=labels[index];tr.append(td);
       });
       tbody.append(tr);
     }
     function addTextRow(label,value,className=''){
       const tr=document.createElement('tr');if(className)tr.className=className;
       const cells=[label,value,'','',''];
       const labels=['Tétel','Érték','','',''];
       cells.forEach((value,index)=>{const td=document.createElement('td');td.textContent=value;if(labels[index])td.dataset.label=labels[index];tr.append(td);});
       tbody.append(tr);
     }

     coverItems.forEach(item=>addMoneyRow(item.label,item.amountNetHuf));
     addMoneyRow('Fedés listaára',coverListNet,'mpc-subtotal');
     addTextRow('Kedvezmény','22%','mpc-discount');
     addMoneyRow('Kedvezményes fedés',discountedCoverNet,'mpc-discounted');

     if(shippingNet===null){
       addTextRow('Szállítási költség','útvonal alapján','mpc-pending');
     }else{
       addMoneyRow('Szállítási költség',shippingNet);
     }
     addMoneyRow('Telepítési költség',installationNet);
     addMoneyRow(total?'Összesen':'Részösszeg szállítás nélkül',netValue,'mpc-total');

     table.append(tbody);lines.append(table);
     lines.hidden=false;
     if(result.rail){
       const segmentText=Number.isInteger(result.rail.segments)?result.rail.segments+' db':'—';
       const segmentLengthText=Number.isInteger(result.rail.segmentLengthMm)?result.rail.segmentLengthMm+' mm':'—';
       const railSides=Number.isInteger(result.rail.railSides)?result.rail.railSides:(result.rail.isPlus?1:2);
       const extensionText=Number.isFinite(result.rail.extensionM)
         ? Math.round(result.rail.extensionM*1000)+' mm'+(railSides===1?' (1 sín)':' / oldal (2 sín)')
         : '—';
       const poolWidthText=Number.isInteger(result.rail.poolWidthMm)?result.rail.poolWidthMm+' mm':(Number.isInteger(current().widthMm)?current().widthMm+' mm':'—');
       const railInnerText=Number.isInteger(result.rail.railInnerWidthMm)?result.rail.railInnerWidthMm+' mm':'—';
       const railWidthText=Number.isInteger(result.rail.railWidthMm)
         ? result.rail.railWidthMm+' mm'+(railSides===1?'':' / oldal')
         : '—';
       const outerWidthText=Number.isInteger(result.rail.outerWidthMm)?result.rail.outerWidthMm+' mm':'—';
       tech.textContent=[
         'Megadott medenceszélesség: '+poolWidthText,
         'Korrigált sínbelső: '+railInnerText,
         'Szegmens szám: '+segmentText,
         'Szegmenshossz (számított): '+segmentLengthText,
         'Sínkivitel: '+result.rail.label,
         'Sínek száma: '+railSides+' db',
         'Sín szélessége: '+railWidthText,
         'Gyári sínkülső: '+outerWidthText,
         'Sínhosszabbítás: '+extensionText
       ].join('\n');
       tech.hidden=false;
     }
     latestQuoteComplete=Boolean(total);
     offerBox.hidden=!latestQuoteComplete;
     status.textContent=total
       ? 'A teljes összeg ellenőrzött szállítási díjjal készült; a műszaki megfelelőséget még egyeztetjük.'
       : 'A szállítás díja a telepítési cím és az útvonal ellenőrzése után kerül hozzáadásra. Ez nem végleges teljes ár.';
   }catch(e){status.textContent='Az árkalkuláció jelenleg nem érhető el. Használd a meglévő ajánlatkérőt.';}
   finally{calculate.disabled=false;}
 });

 offerForm.addEventListener('submit',async(event)=>{
   event.preventDefault();
   if(!latestQuoteComplete){
     offerStatus.textContent='Előbb készítsd el a teljes indikatív árkalkulációt.';
     offerStatus.classList.add('mpc-error');
     return;
   }
   if(!offerForm.reportValidity())return;
   offerSubmit.disabled=true;
   offerStatus.classList.remove('mpc-error');
   offerStatus.textContent='PDF ajánlat készítése és küldése…';
   const customer={
     name:String(offerForm.elements.namedItem('customerName')?.value||'').trim(),
     email:String(offerForm.elements.namedItem('customerEmail')?.value||'').trim(),
     phone:String(offerForm.elements.namedItem('customerPhone')?.value||'').trim()
   };
   try{
     const response=await fetch(root.dataset.offerApi,{
       method:'POST',
       headers:{'Content-Type':'application/json'},
       credentials:'same-origin',
       cache:'no-store',
       body:JSON.stringify({quote:current(),customer})
     });
     const result=await response.json().catch(()=>({}));
     if(response.status===401){
       offerStatus.textContent='Az ajánlat elküldéséhez jelentkezz be.';
       offerStatus.classList.add('mpc-error');
       login.hidden=false;
       return;
     }
     if(!response.ok || result.success===false){
       const fallback='Az ajánlat elküldése nem sikerült.';
       const detail=result.error||fallback;
       const code=result.code?' ('+result.code+')':'';
       const diagnostic=result.detail?' ['+result.detail+']':'';
       const http=!result.error?' (HTTP '+response.status+')':'';
       offerStatus.textContent=detail+code+diagnostic+http;
       offerStatus.classList.add('mpc-error');
       return;
     }
     offerStatus.textContent=result.message||'Az indikatív árajánlatot elküldtük e-mailben.';
   }catch(e){
     offerStatus.textContent='Az ajánlat elküldése jelenleg nem érhető el.';
     offerStatus.classList.add('mpc-error');
   }finally{
     offerSubmit.disabled=false;
   }
 });
})();


  } catch(e) { console.error(e); }
})();
})();
